import React, { useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { Sheet } from '@paypalcorp/pp-react-modal';
import { HeadingText, BodyText } from '@paypalcorp/pp-react-text';
import DropzoneImageHandle from './DropzoneImageHandle';
import { trackEventWithData } from '../../utilsV3/analytics';
import { FPTI_SPEC } from '../../utilsV3/fptiConstants';
import { MessageFormat } from '@paypalcorp/worldready';
import {
  Message,
  Context as WorldReadyContext,
} from '@paypalcorp/worldready-react';

const ImageModal = ({
  isOpen,
  handleCloseModal,
  uploadImage,
  bannerImageUrl,
  isMobile,
}) => {
  const worldReady = useContext(WorldReadyContext);
  const getMessage = (id, formatterObj = {}) => {
    const message = new MessageFormat(worldReady, {
      id: `buttonsV3.imageBanner.modal.bullet.${id}`,
    }).format({ ...formatterObj });
    if (message === `buttonsV3.imageBanner.modal.bullet.${id}`) {
      return '';
    }
    return message;
  };

  useEffect(() => {
    if (isOpen) {
      trackEventWithData(FPTI_SPEC.UPLOAD_BACKGROUND_IMG_MODAL_IM);
    }
  }, [isOpen]);

  const handleDismissClick = () => {
    trackEventWithData(FPTI_SPEC.UPLOAD_BACKGROUND_IMG_MODAL_DISMISS_CL);
    handleCloseModal();
  };

  return (
    <Sheet
      id="image-banner-modal"
      className="image-banner-modal"
      isOpen={isOpen}
      onClose={handleDismissClick}
      hideTitle={true}
    >
      <HeadingText className="banner-modal-title" size="lg">
        <Message id="buttonsV3.imageBanner.modal.title" />
      </HeadingText>
      <BodyText>
        <Message id="buttonsV3.imageBanner.modal.body" />
        <ul>
          <li>{getMessage('0')}</li>
          <li>{getMessage('1')}</li>
          <li>{getMessage('2')}</li>
        </ul>
      </BodyText>
      <DropzoneImageHandle
        uploadImage={uploadImage}
        closeModal={handleCloseModal}
        bannerImageUrl={bannerImageUrl}
        isMobile={isMobile}
      />
    </Sheet>
  );
};

ImageModal.propTypes = {
  isOpen: PropTypes.bool,
  handleCloseModal: PropTypes.func,
  uploadImage: PropTypes.func,
  bannerImageUrl: PropTypes.string,
  isMobile: PropTypes.bool,
};

export default ImageModal;
